/**
 * Where a sense came from.
 *
 * `word_senses.source` is validated for presence only — not inclusion — so the
 * value set is open in practice (the test factory defaults to "test"). Nothing
 * here decides what a source means: a source earns a marker only when an admin
 * has configured a badge for it (see SourceBadge).
 */

/** The minimum any sense-shaped payload needs for a provenance check. */
export interface SenseProvenance {
  source: string
}

/**
 * The distinct sources behind a list of senses, in first-seen order.
 *
 * Used by surfaces that collapse several senses into one line: they must say
 * that a source contributed even when the sense carrying it is never rendered
 * on its own, and must say it once however many senses share it.
 */
export function senseSources(senses: SenseProvenance[]): string[] {
  return [...new Set(senses.map((sense) => sense.source))]
}
